import { render } from "./CourtSidebar.vue?vue&type=template&id=9399633c&ts=true"
import script from "./CourtSidebar.vue?vue&type=script&lang=ts"
export * from "./CourtSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__